import { render } from "./AdicionarQuestaoOpcao.vue?vue&type=template&id=7577c7fd&ts=true"
import script from "./AdicionarQuestaoOpcao.vue?vue&type=script&lang=ts"
export * from "./AdicionarQuestaoOpcao.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__